import React, { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Grid,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Typography,
  CircularProgress,
  InputAdornment,
  Box,
  InputLabel,
} from '@material-ui/core';
import PaginateTable from '../helpers/PaginateTable';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { resendEmailAction, usersAction } from '../../redux/actions/userAction';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import 'react-phone-input-2/lib/style.css';
import SnackAlert from '../helpers/SnackAlert';
import TextTypo from '../helpers/TextTypo';
import { getOrganizationAction } from '../../redux/actions/userAction';
import { getAllBanksAction } from '../../redux/actions/bankActions';
import AutoCompleteSelect from '../../components/application/AutoCompleteSelect';
import Modal from 'components/Modal';
import Button from 'components/Button';
import { Form, Popover } from 'antd';
import Input from 'components/Input';
import Select from 'components/Select';
import { roleAction } from '../../redux/actions/roleAction';
import { createUserAccountAction } from 'redux/actions/authAction';
import { personalEmailHandles, userFilters } from 'utils';
import Radio from 'components/Radio';
import SearchInput from 'components/Input/Search';
import Filter from 'components/Filter';
import Table from 'components/Table';
import { decodeToken } from '../../utils/index';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  modal: {
    backgroundColor: 'white',
    width: '50%',
    padding: '10px 50px',
    height: '70%',
  },
  modalContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalTitle: {
    textAlign: 'center',
  },
});

const Users = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const [form] = Form.useForm();

  const data = decodeToken() !== undefined && decodeToken();

  const columns = [
    {
      title: `${t('firstName')}`,
      dataIndex: 'firstName',
      render: (firstName, record) => {
        return (
          <Popover
            title='User Info'
            placement='rightTop'
            content={() => (
              <div className='d-flex flex-column'>
                <div>
                  <label className='my-1' style={{ fontWeight: 'bold' }}>
                    NID:
                  </label>
                  {record.nid || record?.adminProfile?.nationalId}
                </div>
                <div>
                  <label className='my-1' style={{ fontWeight: 'bold' }}>
                    DOB:
                  </label>
                  {record.dob}
                </div>
                <div>
                  <label className='my-1' style={{ fontWeight: 'bold' }}>
                    Gender:
                  </label>
                  {record.gender}
                </div>
                <div>
                  <label className='my-1' style={{ fontWeight: 'bold' }}>
                    Role:
                  </label>
                  {record.userRole?.RoleName}
                </div>
                <div>
                  <label className='my-1' style={{ fontWeight: 'bold' }}>
                    Preferred Language:
                  </label>
                  {record.preferredLanguage}
                </div>
              </div>
            )}
          >
            <label>{record.firstName + ' ' + record.lastName}</label>
          </Popover>
        );
      },
    },
    {
      title: `${t('lastName')}`,
      dataIndex: 'lastName',
    },
    // {
    //   title: `${t("id-number")}`,
    //   dataIndex: "nationalId",
    //   render: (nid, { adminProfile }) =>
    //     nid || adminProfile?.nationalId || "N/A",
    // },
    {
      title: `${t('phone')}`,
      dataIndex: 'phone',
    },
    {
      title: `${t('email')}`,
      dataIndex: 'email',
    },
    {
      title: `${t('organization')}`,
      dataIndex: 'adminProfile',
      render: (adminProfile) => adminProfile?.organization || 'N/A',
    },
    {
      title: `${t('action')}`,
      dataIndex: 'action',
      render: (action, { id }) => {
        return (
          <div>
            <Tooltip title=''>
              <IconButton onClick={(e) => handleOpenMenu(e, id)}>
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [userId, setUserId] = useState();
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState('');
  const [searchOption, setSearchOption] = useState('names');
  const [filterBy, setFilterBy] = useState({});
  const [customFilters, setCustomFilter] = useState(userFilters);

  const users = useSelector((state) => state.users);
  const email = useSelector((state) => state.email);

  const { allBanks, allRoles, newUser, allOrganisations, usersLoading } =
    useSelector(({ backendUsers, role, users }) => ({
      allBanks: backendUsers?.allBanks?.data,
      allRoles: role.data,
      newUser: backendUsers?.newUser,
      allOrganisations: backendUsers?.allOrganisations?.data,
      usersLoading: users?.loading,
    }));

  const queryData = useCallback((newPage = page, data) => {
    const payload = {
      page: newPage,
      limit: rowsPerPage,
      ...data,
    };
    dispatch(usersAction(payload));
  }, []);

  const handleChangePage = (page, limit) => {
    dispatch(usersAction({ page: page - 1, limit }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseSnack = () => {
    setOpen(!open);
  };

  const handleOpenMenu = (event, id) => {
    setUserId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSendEmail = () => {
    dispatch(resendEmailAction(userId));
    setAnchorEl(null);
    setOpen(true);
  };

  useEffect(() => {
    dispatch(getAllBanksAction());
    dispatch(getOrganizationAction());
    dispatch(roleAction());
    const fetchData = () => {
      queryData(undefined, filterBy);
    };
    fetchData();
  }, [filterBy]);

  useEffect(() => {
    if (newUser?.status === 'success') {
      setOpenModal(false);
      const fetchData = () => {
        queryData();
      };
      fetchData();
    }
  }, [newUser]);

  useEffect(() => {
    const isRoleFilters = customFilters.find((f) => f.value === 'roleId');
    if (allRoles.length && !isRoleFilters) {
      const roleFilter = {
        id: 3,
        value: 'roleId',
        title: 'Role',
        filters: allRoles.map((r) => ({
          id: r.id,
          value: r.id,
          name: r.RoleName,
        })),
      };

      setCustomFilter((prevfilters) => {
        prevfilters.push(roleFilter);
        return prevfilters;
      });
    }
  }, [allRoles]);

  const handleNewUser = () => {
    form.validateFields().then((formData) => {
      if (selectedUserRole === 'Bank Officer') {
        const bank = allBanks?.Banks.find((b) => b.id === formData.scopeValue);
        formData.organization = bank.name;
        formData.scopeField = 'bankId';
      } else {
        const organization = allOrganisations?.organisations.find(
          (b) => b.id === formData.scopeValue
        );
        formData.organization = organization.name;
        formData.scopeField = 'organisationId';
      }
      dispatch(createUserAccountAction(formData));
    });
  };

  const onSearchChange = (e) => {
    const { value } = e.target;
    if (!value) {
      dispatch(usersAction());
    }
  };

  const handleSearch = (value) => {
    let payload = {};
    switch (searchOption) {
      case 'phone':
        payload.phone = value;
        break;

      case 'nationalId':
        payload.nationalId = value;
        break;

      case 'names':
        payload.names = value;
        break;

      case 'email':
        payload.email = value;
        break;

      default:
        payload = {};
    }
    dispatch(usersAction(payload));
  };

  const getPlaceholder = () => {
    switch (searchOption) {
      case 'phone':
        return '07********';

      case 'nationalId':
        return '11927***********';

      case 'names':
        return 'Majyambere';

      case 'email':
        return 'majyambere.joseph@brd.rw';

      default:
        return '';
    }
    dispatch(usersAction(payload));
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Container>
        <Grid container direction='column'>
          <Grid item xs={6}>
            <TextTypo
              text={`${t('users')} (${users?.data?.users?.count || 0})`}
              gutterBottom={true}
              variant='h4'
            />
          </Grid>
          <Grid
            container
            direction='row'
            spacing={2}
            className='d-flex justify-content-between'
          >
            <Grid item xs={6}>
              <Radio
                options={[
                  { label: 'Names', value: 'names' },
                  { label: 'Phone', value: 'phone' },
                  { label: 'National ID', value: 'nationalId' },
                  { label: 'Email', value: 'email' },
                ]}
                value={searchOption}
                onChange={(e) => setSearchOption(e.target.value)}
              />
              <SearchInput
                placeholder={getPlaceholder()}
                onSearch={handleSearch}
                onChange={onSearchChange}
                loading={usersLoading}
                className='my-3 w-75'
              />
            </Grid>

        {data.isSuperAdmin && <Grid
              container
              item
              xs={6}
              justifyContent='flex-end'
              alignItems='center'
            >
              <Button
                type='primary'
                onClick={() => {
                  form.resetFields();
                  setOpenModal(true);
                }}
              >
                Add New User
              </Button>
            </Grid>}
          </Grid>
          <Grid item className={classes.root}>
            {email.message && (
              <SnackAlert
                message={email.message}
                open={open}
                handleClose={handleCloseSnack}
                severity='success'
              />
            )}
            <Modal
              open={openModal}
              onOk={handleNewUser}
              onCancel={() => setOpenModal(false)}
              okText='Add User'
              title='New User Account'
              confirmLoading={newUser?.loading}
            >
              <Form form={form} layout='vertical'>
                <Form.Item
                  name='role'
                  rules={[
                    {
                      required: true,
                      message: 'User role is required',
                    },
                  ]}
                >
                  <Select
                    label='User Role'
                    options={allRoles
                      ?.filter(
                        (r) =>
                          r.RoleName === 'Bank Officer' ||
                          r.RoleName === 'Back-End Officer'
                      )
                      .map((r) => ({
                        label: r.RoleName,
                        value: r.id,
                      }))}
                    placeholder='Select user role'
                    onChange={(value, { label }) => {
                      setSelectedUserRole(label);
                      form.resetFields(['scopeValue']);
                    }}
                    required
                  />
                </Form.Item>
                {selectedUserRole && (
                  <>
                    <Form.Item
                      name='scopeValue'
                      rules={[
                        {
                          required: true,
                          message: 'User organization is required',
                        },
                      ]}
                    >
                      <Select
                        options={(selectedUserRole === 'Bank Officer'
                          ? allBanks?.Banks
                          : allOrganisations?.organisations
                        )?.map((r) => ({
                          label: r.name,
                          value: r.id,
                        }))}
                        label='User organization'
                        placeholder='Select user organization'
                        required
                      />
                    </Form.Item>
                    <Form.Item
                      name='nationalId'
                      rules={[
                        {
                          required: true,
                          message: 'National ID should be valid',
                        },
                      ]}
                    >
                      <Input
                        label='National ID'
                        placeholder='User NID'
                        name='naationalID'
                        required
                      />
                    </Form.Item>
                    <Form.Item
                      name='email'
                      rules={[
                        {
                          required: true,
                          message: 'Email should be valid',
                        },
                        {
                          type: 'email',
                          message: 'Email should be valid',
                        },
                        {
                          validator: (_, value) => {
                            const userHandle = value.split('@')[1];
                            if (
                              userHandle &&
                              personalEmailHandles.includes(userHandle)
                            ) {
                              return Promise.reject(
                                'Personal emails are not allowed. Please use work email'
                              );
                            } else {
                              return Promise.resolve();
                            }
                          },
                        },
                      ]}
                    >
                      <Input
                        label='Email'
                        placeholder='Email Address'
                        name='email'
                        required
                      />
                    </Form.Item>
                    <Form.Item
                      name='phone'
                      rules={[
                        {
                          required: true,
                          message: 'Phone should be valid',
                        },
                      ]}
                    >
                      <Input
                        label='Phone'
                        placeholder='User Phone number'
                        name='phone'
                        required
                      />
                    </Form.Item>
                  </>
                )}
              </Form>
            </Modal>
            <Grid container direction='row'>
              <Grid xs={3}>
                <Filter
                  filterOptions={customFilters}
                  filterBy={filterBy}
                  setFilterBy={setFilterBy}
                />
              </Grid>
              <Grid xs={9}>
                <Table
                  columns={columns}
                  data={users?.data?.users?.rows}
                  total={users?.data?.totalCount}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage}
                />
                <Menu
                  id='simple-menu'
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleCloseMenu}
                >
                  <MenuItem onClick={handleSendEmail}>
                    {t('resend-email')}
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Users;
